export enum EventTypes {
    Start = "STARTED",
    Finalized = "FINALIZED",
    Stopped = "STOPPED",
    Progressed = "PROGRESSED",
}
